import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileActivities = ({ isDarkMode }) => {
    const [activitiesData, setActivitiesData] = useState([]);

    useEffect(() => {
        fetch('/data/activities.json')
            .then(response => response.json())
            .then(data => {
                const activities = [...data].sort((a, b) => b.id - a.id);
                setActivitiesData(activities);
            })
            .catch(error => console.error('Error fetching activities data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Activities</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    <div className="mobile-timeline">
                        {activitiesData.map((activity, index) => (
                            <div key={index} className="mobile-card">
                                <div className="mobile-card-header">
                                    <h3 className="mobile-card-title">{activity.title}</h3>
                                    <span className="mobile-card-period">{activity.period}</span>
                                </div>
                                <p className="mobile-card-description">{activity.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileActivities;
